import { InfoCircleOutlined } from '@ant-design/icons'
import { I18n } from '@components/shared/I18n'
import { store } from '@stores/Store'
import { i18n, I18nKey } from '@utils/i18n'
import { Tooltip } from 'antd'
import clsx from 'clsx'
import { observer } from 'mobx-react'
import React, { CSSProperties, FunctionComponent, ReactNode, useEffect, useState } from 'react'
import styles from './WithTooltip.module.scss'

// Translations carry real newlines (Amway writes bullet lists in the localization
// sheet). An antd tooltip renders its title as plain HTML, where a newline would
// collapse to a space, so the inner element opts into honouring them. 'pre-line'
// rather than 'pre-wrap' because some sheet rows pad blank lines with spaces, and
// only 'pre-line' collapses those back. The info modal does the same via `.info`.
const PRE_LINE_STYLE: CSSProperties = { whiteSpace: 'pre-line' }

export interface WithTooltipProps {
  title: I18nKey | string
  iconPosition?: 'left' | 'right'
  iconFloat?: 'left' | 'right'
  color?: 'white'
  children: ReactNode
}

export const WithTooltip: FunctionComponent<WithTooltipProps> = observer(({ title, iconPosition = 'left', iconFloat, children, color }) => {
  const [locale, setLocale] = useState(store.globalStore.locale)
  useEffect(() => {
    if (locale === store.globalStore.locale) { return }
    setLocale(store.globalStore.locale)
  }, [store.globalStore.locale])

  return (
    <>
      {iconPosition === 'left' && (
        <>
          <Tooltip overlayInnerStyle={PRE_LINE_STYLE} title={<I18n name={(title in i18n) ? i18n[title as I18nKey] : title} />}>
            <InfoCircleOutlined className={clsx(styles['icon'], styles['left'], color && styles['white'])} style={{ marginRight: 4, float: iconFloat }} />
          </Tooltip>
          {children}
        </>
      )}
      {iconPosition === 'right' && (
        <>
          {children}
          <Tooltip overlayInnerStyle={PRE_LINE_STYLE} title={<I18n name={(title in i18n) ? i18n[title as I18nKey] : title} />}>
            <InfoCircleOutlined className={clsx(styles['icon'], styles['right'], color && styles['white'])} style={{ marginRight: 4, float: iconFloat }} />
          </Tooltip>
        </>
      )}
    </>
  )
})
